import Button from "components/common/buttons/buttons";
import { FixedButtonContainer } from "components/common/buttons/FixedButtons";
import TopHeader from "components/common/header";
import { Forward } from "components/common/Icons";
import { SurveyTitle } from "components/templates/common/SAA/util/component";
import SaaSurveyCategoryIndex from "components/templates/common/SAA/util/survey/Category";
import { trackPageAction } from "lib/analytics/core/actions";
import { usePlannerStep } from "lib/analytics/react/hooks";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";

export default function SaaCategory({ isMobile }: { isMobile: boolean }) {
  const router = useRouter();
  const { query } = router;
  const plannerStep = usePlannerStep();
  const abParam = Array.isArray(query.ab) ? query.ab[0] : query.ab;
  const options = [
    {
      id: "car",
      label: "자동차",
    },
    {
      id: "house",
      label: "집",
    },
    {
      id: "travel",
      label: "여행",
    },
    {
      id: "wedding",
      label: "결혼",
    },
    {
      id: "retirement",
      label: "노후 자금",
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0].id);
  const handleOptionSelect = (option: string) => {
    trackPageAction("select_planner_survey");
    setSelectedOption(option);
  };

  const handleNext = () => {
    plannerStep.submit({
      step_key: "q_spend_category",
      step_index: 1,
      outcome: "ok",
    });
    if (selectedOption === "retirement") {
      router.push(`/saa/retire/survey?step=1`);
    } else {
      router.push(`/saa/consume/survey?step=1&cat=${selectedOption}`);
    }
  };

  useEffect(() => {
    plannerStep.view({
      step_key: "q_spend_category",
      step_index: 1,
    });
  }, []);

  return (
    <main
      className="min-w-[360px] max-w-[800px] w-screen bg-bg "
      style={{
        minHeight: isMobile ? "100dvh" : "calc(100vh - 80px)",
      }}
    >
      <TopHeader
        clickHandler={() => {
          router.push("/saa/new");
        }}
      />
      <SaaSurveyCategoryIndex
        onOptionSelect={handleOptionSelect}
        selectedOption={selectedOption}
        options={options}
      />
      <FixedButtonContainer isMobile={isMobile} customStyle={{}}>
        <div className="relative">
          <Button
            size="lg"
            text={"다음"}
            clickHandler={() => {
              handleNext();
            }}
            type="primary"
            btnClass="w-full relative"
            dataGtmId="saa-survey-cat-next-btn"
            dataTestId="saa-survey-cat-next-btn"
            disabled={false}
          />
        </div>
      </FixedButtonContainer>
    </main>
  );
}
